import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

let initialized = false;

export function initPostHog() {
  if (!POSTHOG_KEY || !POSTHOG_HOST) {
    console.warn('PostHog key or host not found. Analytics disabled.');
    return;
  }

  if (!initialized) {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      defaults: '2026-01-30',
      capture_pageview: false,
      persistence: 'localStorage',
      autocapture: true,
      capture_exceptions: true,
      enable_heatmaps: true,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '[data-ph-mask]',
      },
    });
    initialized = true;
  }
}

export function identifyPostHogUser(userId: string, traits?: Record<string, any>) {
  if (!initialized) return;
  posthog.identify(userId, traits);
}

export function capturePostHogEvent(eventName: string, properties?: Record<string, any>) {
  if (!initialized) return;
  posthog.capture(eventName, properties);
}

export function capturePostHogPageview() {
  if (!initialized) return;
  posthog.capture('$pageview');
}

export function resetPostHogUser() {
  if (!initialized) return;
  posthog.reset();
}
